import { IRectangleCoordinatableObject, instanceOfIRectangleCoordinatableObject } from "./IRectangleCoordinatableObject";

export interface IStampObject extends IRectangleCoordinatableObject {}

export function instanceOfIStampObject(instance: any): instance is IStampObject {
  return instanceOfIRectangleCoordinatableObject<IStampObject>(instance, "stamp");
}
